import { useEffect } from "react";

import { redondearDecimales } from "../../../utils/utils_number.js";

const useResumenFE = ({ setFacturaItems, facturaItems, itemsPrecargados, setResumen, formaPago }) => {
  useEffect(() => {
    if (itemsPrecargados?.length > 0) {
      const itemsConIVA = itemsPrecargados.map((item) => ({
        ...item,
        ivaItem: redondearDecimales((item.ventaGravada / 1.13) * 0.13),
      }));
      setFacturaItems(itemsConIVA);
    }
  }, [itemsPrecargados]);

  const calcularFacturaResumen = () => {
    let totalNoSuj = 0,
      totalExenta = 0,
      totalGravada = 0;

    facturaItems.forEach(({ ventaNoSuj = 0, ventaExenta = 0, ventaGravada = 0 }) => {
      totalNoSuj += ventaNoSuj;
      totalExenta += ventaExenta;
      totalGravada += ventaGravada;
    });

    setResumen({
      totalNoSuj: redondearDecimales(totalNoSuj, 2),
      totalExenta: redondearDecimales(totalExenta, 2),
      totalGravada: redondearDecimales(totalGravada, 2),
      formaPago,
    });
  };

  return { calcularFacturaResumen };
};

export default useResumenFE;
